import React, { Fragment } from 'react';
import * as Render from '../platformui/Base/Render';
import { Teaser } from '../platformui/Teaser';
export default (props) => (
  <Fragment>
    {props.RegionAddition && props.RegionAddition.ContentAbove && (
      <Render.Block
        blocks={props.RegionAddition.ContentAbove}
        propertyName="ContentAbove"
        currentPageProps={props}
      >
        <Teaser />
      </Render.Block>
    )}
    <Teaser {...props} Heading={Render.Property(props.Heading, 'Heading')} />
    {props.RegionAddition && props.RegionAddition.ContentBelow && (
      <Render.Block
        blocks={props.RegionAddition.ContentBelow}
        propertyName="ContentBelow"
        currentPageProps={props}
      >
        <Teaser />
      </Render.Block>
    )}
  </Fragment>
);
